import styled from 'styled-components';

export const ResponsiveContainer = styled.div`
  text-align: center;

  h1 {
    font-size: clamp(1.5rem, 4vw, 3rem);
  }

  p {
    font-size: clamp(1rem, 2.5vw, 1.5rem);
  }
`;

export const SeparatorImage = styled.img`
position: absolute;
  width: 100%;
  left: 0;

  transform: translateY(-50%);
  z-index: 0; /* Ensure it doesn't overlap the content */
`;